import "../_config/packs/vue_app";
import { register } from "../_config/packs/register_service_workers";
import { setupFirebase } from "../_config/packs/setup_firebase_integration";

register();
setupFirebase();
